import React from "react";

import { InputForm } from "../Form";

import styles from "./Footer.module.scss";

type NewsletterConfig = {
    registerForNewsletter: (form: HTMLFormElement) => Promise<void>;
};

const newsletterContext = React.createContext<NewsletterConfig>({
    registerForNewsletter: () => Promise.resolve(),
});

export const NewsletterProvider = ({
    children,
    ...value
}: React.PropsWithChildren<NewsletterConfig>) => (
    <newsletterContext.Provider value={value}>
        {children}
    </newsletterContext.Provider>
);

export const NewsletterSignUp = ({
    successMessage,
}: {
    successMessage?: string;
}) => {
    const { registerForNewsletter } = React.useContext(newsletterContext);

    return (
        <>
            <div>
                <InputForm
                    label="Email"
                    name="email"
                    description="Sign up for updates"
                    orchestrateResponse={registerForNewsletter}
                    successMessage={successMessage}
                />
                <p className={styles.grlegal}>
                    This site is protected by reCAPTCHA and the Google{" "}
                    <a href="https://policies.google.com/privacy">
                        Privacy Policy
                    </a>{" "}
                    and{" "}
                    <a href="https://policies.google.com/terms">
                        Terms of Service
                    </a>{" "}
                    apply.
                </p>
            </div>
        </>
    );
};
